import { render, staticRenderFns } from "./DetailsPromotionCard.vue?vue&type=template&id=ba825e5c&scoped=true"
import script from "./DetailsPromotionCard.vue?vue&type=script&lang=ts"
export * from "./DetailsPromotionCard.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPromotionCard.vue?vue&type=style&index=0&id=ba825e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba825e5c",
  null
  
)

export default component.exports